import baseAuthAdminQuery from './baseAuthAdminQuery';

export async function getCurrentUser() {
  const response = await baseAuthAdminQuery({
    path: 'users/current',
    method: 'GET',
  });

  return response?.data;
}

export async function getUserProfile() {
  const response = await baseAuthAdminQuery({
    path: '/profile',
    method: 'GET',
  });
  return response?.data;
}

export async function updateUserProfile({ user, locale }) {
  const response = await baseAuthAdminQuery({
    path: '/profile',
    method: 'POST',
    data: {
      user
    },
    locale,
  });
  return response?.data;
}
